import { Store } from '@ngrx/store';
import { userSelectors } from '@store/selectors/user.selectors';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';
import { Router, RouterLink } from '@angular/router';
@Component({
  selector: 'ac-home-logo',
  templateUrl: './home-logo.component.html',
  styleUrls: ['./home-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, TranslateModule, RouterLink],
  standalone: true,
})
export class HomeLogoComponent {
  @HostBinding('attr.role') role = 'button';
  @HostBinding('attr.tabindex') tabIndex = 0;

  constructor(
    private _store: Store,
    private _router: Router
  ) {}

  protected _goHome(): void {
    const user = this._store.selectSignal(userSelectors.authUser)();
    const isEnergyRehabilitationMode = this._store.selectSignal(userSelectors.isEnergyRehabilitationMode)();
    const currentUrlTree = this._router.parseUrl(this._router.url);
    const currentPath = currentUrlTree.root.children['primary']?.segments.map((segment) => segment.path).join('/') ?? '';
    const isRehabilitationFromQuery = currentUrlTree.queryParams['rehab'] === 'true';
    const isRehabilitationRoute = currentPath === 'consumption-invoices' || currentPath.startsWith('consumption-invoices/');

    // Keep rehabilitation route when navigating from any rehabilitation context.
    if (isEnergyRehabilitationMode || isRehabilitationRoute || isRehabilitationFromQuery) {
      this._router.navigate(['/consumption-invoices']);
      return;
    }

    if (!user) {
      this._router.navigate(AcRoutingService.HOME_ROUTE());
      return;
    }

    const isComercializadora = user.informationCommercializer;
    const isRehabilitacion = user.informationRehabilitation;

    // 👉 solo rehabilitación
    if (isRehabilitacion && !isComercializadora) {
      this._router.navigate(['/consumption-invoices']);
      return;
    }

    // 👉 resto → home
    this._router.navigate(AcRoutingService.HOME_ROUTE());
  }
}
